import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PageHeader.scss';
import { FaBars } from 'react-icons/fa';
import useInactivityTimer from '../../hooks/useInactivityTimer';
import { AxiosGet } from '../http/Axios';

const PageHeader = (props) => {
  const inactivityMinutes =
    parseInt(process.env.REACT_APP_INACTIVITY_MINUTES || "20", 10);

  useInactivityTimer(inactivityMinutes);
  const { title } = props;
  const dropdownRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const allowedUsers = (process.env.REACT_APP_ALLOWED_USERS || "")
    .split(",")
    .map(u => u.trim().toLowerCase());

  useEffect(() => {
    const fetchEmail = async () => {
      try {
        const response = await fetch('/kidlab-reg/admin/api/whoami');
        if (response.ok) {
          const data = await response.json();
          setEmail(data.email || 'unknown');
          sessionStorage.setItem("loggedInAs", data.email || 'unknown');
        } else {
          console.error('Failed to fetch email');
        }
      } catch (error) {
        console.error('Error fetching email:', error);
      }
    };

    fetchEmail();
  }, []);

  const handleNavigation = (path) => {
    console.log(`Navigating to: ${path}`);
    navigate(`${path}`);
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await fetch('/kidlab-reg/admin/logout', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (err) {
      console.error('Logout API failed:', err);
    }

    sessionStorage.clear();
    localStorage.removeItem('authToken');
    setEmail('');

    navigate('/login');
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <div className="main-page-header">
      <header className="page-header">
        <div className="menu-container">
          <div className="menu-icon" onClick={toggleMenu} title="Open Menu">
            <FaBars />
            <span className="menu-title">Menu</span>
          </div>
        </div>
        <div className="title">
          <h2>{title}</h2>
        </div>
        <div className="user-details">
          <p>
            <span>Logged In As: </span>
            <strong>{email}</strong>
          </p>
          <p>
            <a href="#" onClick={handleLogout} className="logout-link">
              Log Out
            </a>
          </p>
        </div>
      </header>

      {menuOpen && (
        <nav className="dropdown-menu" ref={dropdownRef}>
          <ul>
            <li>
              <a href="#" onClick={() => handleNavigation('/search-page')}>
                Search Families and Children
              </a>
            </li>
            <li>
              <a href="#" onClick={() => handleNavigation('/add-family')}>
                Add Family
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={() => handleNavigation('/registration-report')}
              >
                Registration Report
              </a>
            </li>
            {allowedUsers.includes(email.toLowerCase()) && (
              <li>
                <a href="#" onClick={() => handleNavigation('/users')}>
                  User Administration
                </a>
              </li>
            )}
            <li>
              <a href="#" onClick={handleLogout}>
                Log Out
              </a>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default PageHeader;
